/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Artifacts_Count_OtherInputs */



/**
* | output |
* | --- |
* | "{count} Artifacts" |
*
* @param {Artifacts_Count_OtherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_count_other = /** @type {((inputs: Artifacts_Count_OtherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Count_OtherInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Artefakte`)
	return /** @type {LocalizedString} */ (`${i?.count} Artifacts`)
});